<template>
  <b-alert
    :show="hasDialogMessage"
    :variant="dialogMessageVariant"
    dismissible
    fade
    @dismissed="clearDialogMessage"
  >
    {{ dialogMessage }}
  </b-alert>
</template>

<script>
import notifications from "@foys-tech/foys-utils/notifications";
import { mapGetters, mapActions } from "vuex";
export default {
  methods: {
    ...mapActions("notifications", ["clearDialogMessage"]),
  },
  computed: {
    ...mapGetters("notifications", [
      "dialogMessage",
      "dialogMessageVariant",
      "hasDialogMessage",
    ]),
  },
  created() {
    if (!this.$store.hasModule("notifications")) {
      notifications.namespaced = true;
      this.$store.registerModule("notifications", notifications);
    }
  },
};
</script>